/* Pooltime swatches and app-media filtering for Viola's 2.0.9 variant events. */
(() => {
  if (window.pooltimeVariantSwatchesLoaded) return;
  window.pooltimeVariantSwatchesLoaded = true;

  function refresh(section) {
    const picker = section.querySelector('variant-selects');
    const dataNode = section.querySelector('[data-pooltime-variant-data]');
    if (!picker || !dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    const selection = {};
    picker.querySelectorAll('input[type="radio"]:checked').forEach(input => {
      selection[input.dataset.optionName || input.name] = input.value;
    });
    picker.querySelectorAll('select[name^="options["]').forEach(input => {
      selection[input.name.slice(8, -1)] = input.value;
    });

    picker.querySelectorAll('input[type="radio"][data-option-name]').forEach(input => {
      const label = Array.from(input.labels || []).find(node => picker.contains(node));
      if (!label) return;
      label.classList.toggle('active', input.checked);
      // Native colour swatches retain their merchant-provided colours/images.
      if (!label.classList.contains('variant-image-swatch')) return;
      const proposed = { ...selection, [input.dataset.optionName]: input.value };
      const variant = data.variants.find(item => data.options.every((name, index) =>
        proposed[name] === undefined || item.options[index] === proposed[name]
      ));
      const url = variant?.featured_image?.src || variant?.image?.src;
      if (url) label.style.backgroundImage = `url(${JSON.stringify(url)})`;
      // Availability is supplied by Shopify's new option-value response.
    });

    section.querySelectorAll('.thumbnail-list__item img, .product__media img').forEach(img => {
      const isAppOptionImage = (img.alt || '').toLowerCase().includes('option image') ||
        (img.getAttribute('src') || '').includes('dpo_custom_option_');
      if (!isAppOptionImage) return;
      const wrapper = img.closest('.thumbnail-list__item, .product__media, .slider__slide');
      if (wrapper) wrapper.style.display = 'none';
    });
  }

  const refreshAll = () => document.querySelectorAll('section[id^="MainProduct-"]').forEach(refresh);
  document.addEventListener('DOMContentLoaded', refreshAll);
  document.addEventListener('shopify:section:load', refreshAll);
  document.addEventListener('change', event => {
    const section = event.target.closest('section[id^="MainProduct-"]');
    if (section && event.target.closest('variant-selects')) refresh(section);
  });
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const section = document.getElementById(`MainProduct-${event.data.sectionId}`);
      if (!section) return;
      refresh(section);
      section.querySelectorAll('.variant-sku, .Artikelnr-capitalize').forEach(node => {
        node.textContent = event.data.variant?.sku || '';
      });
    });
  }
  if (document.readyState !== 'loading') refreshAll();
})();
